import React, { useMemo } from "react";

import ToggleSwitch from "../../../atoms/ToggleSwitch";
import useDebounceCallback from "../../../hooks/useDebounceCallback";
import { IAnswersByClass } from "../../../state";

export type Props = {
  label: string;
  answersByClass: IAnswersByClass;
  type: "answer_opened" | "name_opened";
  onChange: (id: number, check: boolean) => void;
};

const SwitchBox: React.FC<Props> = ({
  label,
  answersByClass,
  type,
  onChange,
}) => {
  const checked = useMemo(() => !!answersByClass[type], [answersByClass, type]);

  const [debounced] = useDebounceCallback((check: boolean) =>
    onChange(answersByClass.id, check),
  );

  return (
    <ToggleSwitch
      label={label}
      checked={checked}
      id={answersByClass.id.toString() + type}
      onChange={() => {
        debounced(!checked!);
      }}
    />
  );
};

export default SwitchBox;
